function playPauseVideo(slick, control){
    var currentSlide, slideType, startTime, player, video;
  
    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.attr("class").split(" ")[1];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");
  
    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value" : startTime
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value" : 1
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    } else if (slideType === "youtube") {
  
      switch (control) {
        case "play":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "unMute"
          });
          postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {
      video = currentSlide.children("video").get(0);
      if (video != null) {
        if (control === "play"){
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }
  
  function postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }
  
  jQuery(document).ready(function($){
    jQuery('.page-main-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      fade: true,
      asNavFor: '.page-thumbnails-slider'
    }).on('afterChange', function(event, slick, currentSlide, nextSlide) { 
      
         slick = $(slick.$slider);
       playPauseVideo(slick,"play");
      
  
    });
    
     var slideWrappers = $('.page-main-slider');
     slideWrappers.on("beforeChange", function(event, slick,currentSlide) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"pause");
  //     $('.zoomContainer').remove();
      
    });
    
    jQuery('.page-thumbnails-slider').slick({
      swipeToSlide: true,
      arrows: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.page-main-slider',
      dots: false,
      infinite: false,
      centerMode: false,
      focusOnSelect: true,
      vertical: true,
      verticalSwiping: true,
      responsive: [
        {
          breakpoint: 1261,
          settings: {
           slidesToShow: 5,
           vertical: false,
           verticalSwiping: false,
           arrows: false,
           infinite: true
          }
        }
      ]
    });
    jQuery('.section-related-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 861,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    
  });


//  jQuery(document).ready(function(){
//   jQuery('.nws-lp-tv-seen-on-slide').slick({
//       dots: false,
//       arrows: true,
//       infinite: true,
//       adaptiveHeight: false,
//       slidesToShow: 7,
//       focusOnSelect: true,
//       autoplay: true,
//       slidesToScroll: 1,
//       responsive: [{
//           breakpoint: 1171,
//           settings: {
//               dots: true,
//               arrows: false,
//               slidesToShow: 7,
//               slidesToScroll: 1
//           }
//       },{
//           breakpoint: 1281,
//           settings: {
//               dots: true,
//               arrows: false,
//               slidesToShow: 6,
//               slidesToScroll: 1
//           }
//       },{
//           breakpoint: 840,
//           settings: {
//               dots: true,
//               arrows: false,
//               slidesToShow: 3,
//               slidesToScroll: 1
//           }
//       },{
//           breakpoint: 580,
//           settings: {
//               dots: true,
//               arrows: false,
//               slidesToShow: 1,
//               slidesToScroll: 1
//           }
//       }]
//   });  
// });    
  
    $('.single-option-selector').change(function(){
  
      var vall = $(".product-form__variants").val();
  
      $(".buy-now-button.btn").attr("href",'/cart/'+vall+':1');
      
      var selectedVariant = '';
      $('.single-option-selector').each(function(index){
        var selected_value =$('.single-option-selector').eq(index).val();
        if(selectedVariant){
          selectedVariant = selectedVariant + " / " + selected_value;
        } else {
          selectedVariant = selected_value;
        }
         $('select[name="id"] option').removeAttr('selected');
        $('select[name="id"]').find("[data-title='" + selectedVariant + "']").attr("selected","selected");
      });
      
      $(document).ready(function() {
    function updateBuyNowButton() {
        var selectedVariantId = $('select[name="id"]').val();
        var button = $(".buy-now-button.btn");
        var currentHref = button.attr("href");

        if (selectedVariantId && selectedVariantId !== "") {
            var newHref = '/cart/' + selectedVariantId + ':1';
            if (currentHref !== newHref) {
                button.attr("href", newHref);
                console.log("Buy Now button updated with selected variant: " + selectedVariantId);
            }
        } else {
            var firstVariantId = $('select[name="id"] option:first').val();
            var defaultHref = '/cart/' + firstVariantId + ':1';
            if (currentHref !== defaultHref) {
                button.attr("href", defaultHref);
                console.log("No variant selected. Defaulting to first variant: " + firstVariantId);
            }
        }
    }

    function validateVariantId(variantId) {
        // Check if the variant ID is valid
        // Here you would need to define how to check if the variant ID is valid
        // For simplicity, let's assume any non-empty ID is valid
        return variantId && variantId !== "";
    }

    // Update the button whenever a variant is changed
    $('select[name="id"]').change(function() {
        var selectedVariantId = $(this).val();
        if (validateVariantId(selectedVariantId)) {
            updateBuyNowButton();
            console.log("Variant changed, Buy Now button updated.");
        } else {
            console.log("Invalid variant ID selected.");
        }
    });

    // Initial button setup to ensure the button is correct when the page loads
    updateBuyNowButton();
    console.log("Initial Buy Now button setup.");
});
  
      
      
      // Sold out js When master select changes
  //         $('select[name="id"] option').each(function(){
  //           if ($(this).text().indexOf(selectedVariant) > -1 && $(this).text().indexOf('Sold out') > -1 ){
  //             //console.log('if',$(this).text() );
  //             $('.product-form__cart-submit').attr('disabled','disabled').text('Sold Out');
  //             return false;
  //           }else{
  //             //console.log('els', $(this).text());
  //             $('.product-form__cart-submit').removeAttr('disabled').text('Add to cart');
  //           }
  //         });
      
      
        var checkstring = false;
      $('select[name="id"] option').each(function(){
        var checktext = $(this).text().indexOf(selectedVariant);
        var checksoldout = $(this).text().indexOf('Sold out');
        if(checktext > -1 ){
           checkstring = true;
          if(checksoldout > -1 ){
          checkstring = false;
          return false;
          }
        }
      });
      if(checkstring){
         $('.product-form__cart-submit').removeAttr('disabled').text('Add to cart');
      }
      else{
        $('.product-form__cart-submit').attr('disabled','disabled').text('Sold Out');
      }
  
      var get_value = $("#ProductSelect-aline-landing option:contains('"+ selectedVariant +"')").val();
      $("#ProductSelect-aline-landing").val(get_value);
    });
  
  
  //   $('.page-main-slider .slide-wrap').mouseover(function() {
     
  //     var allid = $(this).children().attr('id');
  //     $('#'+allid+'').click(function(){
        
  //       var cur_id = $(this).attr('id');
  //       if ($(window).width() > 768) {
  //       $('#'+cur_id+'').elevateZoom(); 
  //       }
  //     })
  //   });
  
  // $(window).resize(function(e){
  //         $('.zoomContainer').remove();
  //    var thumbid = $('.page-main-slider .slide-wrap').children().attr('id');
  //    $('#'+thumbid+'').click(function(){
  //      var tcur_id = $(this).attr('id');
  //         $('#'+tcur_id+'').elevateZoom({
  //             zoomType: "inner",
  //             cursor: "crosshair",
  //             easing: true,
  //         });
  //    });
  //     }); 
  


$('.nws-lp-tv-seen-on-slide').slick({
    dots: false,
    arrows: true,
    infinite: true,
    adaptiveHeight: false,
    slidesToShow: 7,
    focusOnSelect: true,
    autoplay: true,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1281, // Larger screens
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 6,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1171, // Medium screens
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 5, // Adjusted for better scaling
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 840, // Tablets
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 580, // Small screens
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});


  
AOS.init({
    once: true
});
